// export const BACKEND_URL = "http://172.16.11.245:5000/api";
// export const IMAGE_BASE_URL = "http://172.16.11.245:5000";

// export const BACKEND_URL = "https://petlover-dating-api.devtechnosys.tech/api";
// export const IMAGE_BASE_URL = "https://petlover-dating-api.devtechnosys.tech";

export const BACKEND_URL = "https://api.themuttznutz.com/api";
export const IMAGE_BASE_URL = "https://api.themuttznutz.com";

// export const BACKEND_URL = "http://localhost:8001/api";
// export const IMAGE_BASE_URL = "http://localhost:8001";

// export const BACKEND_URL = "http://172.16.12.57:8001/api";
// export const IMAGE_BASE_URL = "http://172.16.12.57:8001";

// export const BACKEND_URL = "http://172.16.0.141:8001/api";
// export const IMAGE_BASE_URL = "http://172.16.0.141:8001";

export const MOBILE_REGEX = /^[0-9]{10}$/;

// export const PASSWORDS_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%^&*?])[A-Za-z\d#$@!%^&*?]{8,}$/;
export const PASSWORDS_REGEX =
  /^(?=\S{8,})(?=\S)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\p{L}\p{N}\s]).*$/u;

export const EMAIL_REGEX =
  /^(?![.+-])([a-zA-Z0-9._+-]+)(?!\.)[a-zA-Z0-9]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;

export const NOSPACE_REGEX = /^[^\s]+(\s+[^\s]+)*$/;

export const REMOVENBSP = /&nbsp;/g;
export const NOSPACE = "Spaces are not allowed";

export const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/mp4",
  "video/x-ms-wmv",
  "video/quicktime",
  "video/webm",
  "application/pdf",
  "text/plain",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const MULTIPLESPACE = /  +/g;

export const CARD_REGEX =
  /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/g;

export const NODIGITREGEX = /^([^0-9]*)$/;

export const DECIMALPATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;

export const REMOVEHTML = /(<([^>]+)>)/gi;

// kaam k

export const STATUS_OPTIONS = ["active", "suspended", "pending"];
export const PET_OPTIONS = ["dog", "cat", "other"];
export const ADMIN_ROLE_OPTIONS = [
  "super_admin",
  "support_admin",
  "finance_admin",
  "marketing_admin",
];

export const ORGANIZSER_verificationStatus = [
  "pending",
  "verified",
  "rejected",
  "suspended",
];
export const ORGANIZSER_status = ["active", "inactive", "suspended"];
export const ORGANIZER_STATUS_OPTIONS = [
  "pending",
  "approved",
  "rejected",
  "suspended",
  "inactive",
];
export const ORGANIZER_type = [
  "event_organizer",
  "pet_cafe",
  "park",
  "breeder",
  "rescue",
  "vet_clinic",
  "grooming_salon",
  "training_center",
  "other",
];

export const EVENT_CATEGORY_OPTIONS = [
  "playdate",
  "adoption_drive",
  "breed_meetup",
  "training_workshop",
  "cafe_pet_day",
  "other",
];

export const EVENT_STATUS_OPTIONS = [
  "approved",
  "rejected",
  "pending",
  "cancelled",
];

export const VENDOR_STATUS_OPTIONS = [
  "pending",
  "approved",
  "rejected",
  "suspended",
  "inactive",
];

export const PRODUCT_STATUS_OPTIONS = [
  "pending",
  "approved",
  "rejected",
  "flagged",
];

// Add this near the top with other constants
export const GENDER_OPTIONS = ["man", "woman", "nonbinary", "lesbian", "gay"];

export const sanitizeSearch = (value) => {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "");
};

/** MUI `sx` for list toolbar search — fixed width on sm+ (avoids resize on focus/typing). */
export const SEARCH_FIELD_SX = {
  width: { xs: "100%", sm: 280 },
  minWidth: { xs: "100%", sm: 280 },
  maxWidth: { xs: "100%", sm: 280 },
  flexShrink: 0,
};

/** Shared list page layout — match Vendor Management styling. */
export const LIST_PAGE_HEADER_SX = {
  px: { xs: 2, sm: 3 },
  py: { xs: 1.5, sm: 2 },
  "& .MuiCardHeader-title": {
    fontSize: { xs: "1.1rem", sm: "1.25rem" },
  },
};

export const LIST_PAGE_TOOLBAR_SX = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  flexWrap: "wrap",
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "flex-end",
  p: { xs: 1.5, sm: 2 },
  gap: 1.5,
  "& > .MuiFormControl-root, & > .MuiInput-root, & > .MuiButton-root": {
    width: { xs: "100%", sm: "auto" },
  },
  "& > .MuiInput-root": {
    maxWidth: { xs: "100%", sm: 280 },
  },
};

export const LIST_PAGE_CARD_CONTENT_SX = {
  px: { xs: 1, sm: 2 },
  py: { xs: 1, sm: 2 },
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
};

export const LIST_PAGE_ADD_BUTTON_SX = {
  whiteSpace: "nowrap",
  width: { xs: "100%", sm: "auto" },
};

export const LIST_PAGE_TABLE_CUSTOM_STYLES = {
  table: {
    style: {
      backgroundColor: "#ffffff",
      width: "100%",
    },
  },
  headRow: {
    style: {
      minHeight: "48px",
      backgroundColor: "#f8fafc",
      borderTop: "1px solid #e2e8f0",
      borderBottom: "2px solid #e2e8f0",
    },
  },
  rows: {
    style: {
      minHeight: "54px",
      fontSize: "0.875rem",
      color: "#334155",
      "&:not(:last-of-type)": {
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "#f1f5f9",
      },
      "&:hover": {
        backgroundColor: "#f8fafc",
        transition: "all 0.15s ease-in-out",
      },
    },
    stripedStyle: {
      backgroundColor: "#fafbfd",
    },
  },
  headCells: {
    style: {
      fontWeight: "700",
      fontSize: "0.8125rem",
      letterSpacing: "0.03em",
      textTransform: "uppercase",
      color: "#475569",
      paddingLeft: "14px",
      paddingRight: "14px",
      alignItems: "center",
      whiteSpace: "nowrap",
    },
  },
  cells: {
    style: {
      paddingLeft: "14px",
      paddingRight: "14px",
      wordBreak: "break-word",
      fontSize: "0.875rem",
      color: "#1e293b",
      alignItems: "center",
    },
  },
};

export const getListPageTableCustomStyles = (minWidth = 1000) => ({
  ...LIST_PAGE_TABLE_CUSTOM_STYLES,
  table: {
    style: {
      ...LIST_PAGE_TABLE_CUSTOM_STYLES.table.style,
      minWidth: typeof minWidth === "number" ? `${minWidth}px` : minWidth,
    },
  },
});

/** Allowed characters for admin list search (names, emails, ids). */
export const SEARCH_INPUT_CHAR_REGEX = /^[A-Za-z0-9\s@._+-]*$/;

export const PETSITTER_STATUS_OPTIONS = [
  "pending",
  "approved",
  "rejected",
  "suspended",
  "inactive",
];
export const PETSITTER_SERVICE_OPTIONS = [
  "dog_walking",
  "pet_sitting",
  "overnight_care",
  "pet_grooming",
  "vet_visits",
  "pet_training",
  "day_care",
];

export const PET_SPOT_PLACE_TYPES = [
  "park",
  "cafe",
  "beach",
  "restaurant",
  "hotel",
  "other",
];

export const getPetSpotPlaceTypeLabel = (type) => {
  if (!type) return "N/A";
  const placeTypeLabels = {
    park: "Park",
    cafe: "Cafe",
    beach: "Beach",
    restaurant: "Restaurant",
    hotel: "Hotel",
    accommodation: "Accommodation",
    other: "Other",
  };
  if (placeTypeLabels[type]) {
    return placeTypeLabels[type];
  }
  return String(type)
    .split(/[_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const PET_SPOT_COST_TYPES = ["free", "paid"];

export const PET_SPOT_FACILITIES = [
  "water",
  "playground",
  "veterinary",
  "parking",
  "restroom",
  "wifi",
  "food",
  "shade",
];

export const STATUS_OPTIONS_LIST = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const ALL_MANAGEMENT_PERMISSIONS = {
  Dashboard: true,
  "Admin Management": true,
  "User Management": true,
  "Organizer Management": true,
  "Vendor Management": true,
  "Petsitter Management": true,
  "Subscription Management": true,
  "Entities Management": true,
  "Reviews Management": true,
  "Payments & Payouts": true,
  "User Reports": true,
  "Category Management": true,
  "Pet Spots Management": true,
  "Support & Feedback": true,
  "FAQ Management": true,
  "About Us": true,
  "Community Guidelines": true,
  "Privacy Policy": true,
  "Terms & Conditions": true,
  "Event Guidelines": true,
  "Refund Policies": true,
  "Other CMS": true,
  "Landing Page Management": true,
  "Marketing & Notifications": true,
  "Marketing Management": true,
  "Pet Quiz Management": true,
};

// Permission options for dropdown (array format)
export const PERMISSION_OPTIONS = Object.keys(ALL_MANAGEMENT_PERMISSIONS);

// Marketing Campaign Constants
export const CAMPAIGN_TYPES = [
  { value: "push_notification", label: "Push Notification" },
  { value: "email", label: "Email" },
];

export const NOTIFICATION_TYPES = [
  { value: "new_matches", label: "New Matches/Messages" },
  { value: "event_reminder", label: "Event Reminder" },
  { value: "promotional_offer", label: "Promotional Offer" },
  { value: "system_update", label: "System Update" },
  { value: "newsletter", label: "Newsletter" },
  { value: "custom", label: "Custom" },
];

export const TARGET_AUDIENCES = [
  { value: "all_users", label: "All Users" },
  { value: "specific_users", label: "Specific Users" },
  { value: "partners", label: "Partners" },
];

export const SCHEDULE_TYPES = [
  { value: "send_now", label: "Send Now" },
  { value: "scheduled", label: "Schedule for Later" },
];

export const SUBSCRIPTION_STATUS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "free", label: "Free" },
  { value: "premium", label: "Premium" },
];

export const HAS_PET_OPTIONS = [
  { value: "all", label: "All" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const CAMPAIGN_STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "scheduled", label: "Scheduled" },
  { value: "sending", label: "Sending" },
  { value: "sent", label: "Sent" },
  { value: "failed", label: "Failed" },
  { value: "cancelled", label: "Cancelled" },
];
